import { Controller } from '@hotwired/stimulus'
import {  enter, leave  } from "./../helpers/transition"

export default class extends Controller {
  static targets = ['progress']
  static values = {
    dismissAfter: Number,
    showDelay: { type: Number, default: 0 },
  }

  // Never let more than this stack up on screen at once.
  static MAX_VISIBLE = 3

  connect() {
    this.trimOverflow()

    setTimeout(() => {
      enter(this.element)
    }, this.showDelayValue)

    // Auto dimiss if defined
    if (this.hasDismissAfterValue) {
      this.progressTarget.style.animationDuration = this.dismissAfterValue + 'ms'
      setTimeout(() => {
        this.close()
      }, this.dismissAfterValue)
    }
  }

  // A burst of saves would otherwise pile a column of toasts down the
  // screen. Drop the oldest so only the newest few remain. The hidden
  // #toast_template is skipped — it is the clone source, not a toast.
  trimOverflow() {
    const container = this.element.closest('#toasts')
    if (!container) return
    const live = Array.from(container.children).filter(
      (el) => el.id !== 'toast_template' && !el.classList.contains('hidden')
    )
    live.slice(0, Math.max(0, live.length - this.constructor.MAX_VISIBLE))
        .forEach((el) => el.remove())
  }

  // Runs hide animation and then removes element from the page
  close() {
    const element = this.element
    element.classList.add('animate__animated','animate__bounceOutRight')
    element.addEventListener('animationend', () => {
      setTimeout(() => {
        this.element.remove()
      }, 500)
    });
  }
}
